import { useEffect, useRef, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux"
import { fetchSocialAccountCreatorsThunk } from "slices/socialAccounts/thunk";
import { AppDispatch, RootState } from "store";
import { formatNumber, generateUniqueKey, getSocialAccountProfileURL } from "utils/helpers";
import userProfilePicture from "../../../assets/images/users/user-dummy-img.jpg";
import Skeleton from "react-loading-skeleton";
import IGLogoPNG from "../../../assets/images/brands/ig-logo.png"
import { setCreatorsFilters } from "slices/socialAccounts/reducer";
import { defaultSocialAccountCreatorsFilters, SocialAccountCreator } from "types/social-account";
import FollowersIcon from "assets/icons/mono/FollowersIcon";
import { UncontrolledTooltip } from "reactstrap";
import CreatorCard from "./CreatorCard";
import { toggleManageCollectionModal } from "slices/ui/reducer";
const SocialAccountCreators: React.FC<{ socialAccountId: string }> = ({ socialAccountId }) => {

    const dispatch: AppDispatch = useDispatch();
    const filters = useSelector((state: RootState) => state.socialAccountState.creators.filters);
    const [filterId, setFilterId] = useState(generateUniqueKey(filters, ['page']));
    const [initialLoading, setInitialLoading] = useState(true);
    const debounceTimeout = useRef<NodeJS.Timeout | null>(null);
    const loading = useSelector((state: RootState) => state.socialAccountState.creators.loading);
    const creatorsData = useSelector((state: RootState) => state.socialAccountState.creators.items[socialAccountId!]?.filtered_lists?.[filterId!]);
    const hasMore = creatorsData?.has_more ?? true;
    const page = creatorsData?.page ?? 1;
    const creators = creatorsData?.items ?? [];
    const error = useSelector((state: RootState) => state.socialAccountState.creators.error);

    useEffect(() => {
        dispatch(setCreatorsFilters(defaultSocialAccountCreatorsFilters));
    }, [])

    useEffect(() => {
        if (socialAccountId && filters) {
            if (filters.page && filters.page === 1) {
                setInitialLoading(true);
            }
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }
            debounceTimeout.current = setTimeout(() => {
                dispatch(fetchSocialAccountCreatorsThunk({ socialAccountId, filters })).finally(() => {
                    setInitialLoading(false);
                    setFilterId(generateUniqueKey(filters, ['page']))
                })
            }, 500)
        }
    }, [socialAccountId, filters])

    const nextPage = () => {
        if (hasMore && socialAccountId && !loading) {
            const nextPageNumber = page + 1;
            dispatch(fetchSocialAccountCreatorsThunk({ filters: { ...filters, page: nextPageNumber }, socialAccountId }))
        }
    }

    const bookmark = (e: any, creator: SocialAccountCreator) => {
        e.stopPropagation();
        e.preventDefault();
        dispatch(toggleManageCollectionModal({ post: null, creator: creator.social_account, itemType: 'account', addMode: true }))
    }

    return (
        <InfiniteScroll
            dataLength={creators.length}
            next={nextPage}
            hasMore={hasMore}
            loader={<></>}
            className="creator-grid"
        >
            {creators.map((creator, i) => (
                <div key={i}>
                    <CreatorCard creator={creator} onHoverActions={
                        <span onClick={(e) => bookmark(e, creator)} className="position-absolute" style={{ right: '8px', top: '8px', left: 'none' }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M17.5 13.4084V9.24728C17.5 5.67344 17.5 3.88652 16.4017 2.77627C15.3033 1.66602 13.5355 1.66602 10 1.66602C6.46447 1.66602 4.6967 1.66602 3.59835 2.77627C2.5 3.88652 2.5 5.67344 2.5 9.24728V13.4084C2.5 15.9889 2.5 17.2791 3.11176 17.8429C3.40351 18.1118 3.77179 18.2807 4.1641 18.3256C4.98668 18.4198 5.94728 17.5701 7.86847 15.8709C8.71768 15.1198 9.14229 14.7442 9.63356 14.6452C9.87548 14.5965 10.1245 14.5965 10.3664 14.6452C10.8577 14.7442 11.2823 15.1198 12.1315 15.8709C14.0527 17.5701 15.0133 18.4198 15.8359 18.3256C16.2282 18.2807 16.5965 18.1118 16.8882 17.8429C17.5 17.2791 17.5 15.9889 17.5 13.4084Z" stroke="white" strokeWidth="1.25" />
                                <path d="M12.5 5H7.5" stroke="white" strokeWidth="1.25" strokeLinecap="round" />
                            </svg>
                        </span>
                    } />
                </div>
            ))}
            {
                (loading || initialLoading) && Array.from({ length: 4 }).map((_, i) => (
                    <Skeleton height={'270px'} className='w-100 d-block' />
                ))
            }
            {
                !(loading || initialLoading) && error &&
                <div className="py-3 d-flex justify-content-center align-items-center">
                    <button className="theme-btn theme-btn-sm btn-primary-outlined" onClick={nextPage}>Load More <i className='ms-2 fs-5 bx bx-refresh'></i></button>
                </div>
            }
            {
                !(loading || initialLoading) && creators.length === 0 &&
                <div className="d-flex w-100 justify-content-center align-items-center my-5">
                    <div className="length-zero my-5">
                        <h3>Currently there is no creator in your list</h3>
                    </div>
                </div>
            }
        </InfiniteScroll>
    )
}

export default SocialAccountCreators
